module.exports = __webpack_public_path__ + "img/White Mocha.7b995911.svg";